module.exports = __webpack_public_path__ + "pLogin.0d9fd4e019c4638d972e.png";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Partners-Pipeline/src/assets/pLogin.png
// module id = ../../../../../src/assets/pLogin.png
// module chunks = styles